export enum RewardCategory {
	FreeProduct = "free_product",
	Discount = "discount",
}

export enum CouponDurationType {
	OneOff = "one_off",
	Months = "months",
	Forever = "forever",
}

export enum DiscountType {
	Percentage = "percentage",
	Fixed = "fixed",
}

export enum RewardType {
	PercentageDiscount = "percentage_discount",
	FixedDiscount = "fixed_discount",
	FreeProduct = "free_product",
	InvoiceCredits = "invoice_credits",
	FeatureGrant = "feature_grant",
}
